/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Method_TabInputs */



/**
* | output |
* | --- |
* | "Payment Method" |
*
* @param {Payment_Method_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const payment_method_tab = /** @type {((inputs?: Payment_Method_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Method_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode de paiement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlungsmethode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metodo di pagamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Способ оплаты")
	if (locale === "es") return /** @type {LocalizedString} */ ("Método de pago")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("付款方式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("支払方法")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भुगतान विधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Método de pagamento")
	return /** @type {LocalizedString} */ ("Payment Method")
});